import { Group } from '@mantine/core';
import { UploadedFile } from 'src/data-capture/hooks/file-uploads/types';
import DownloadDocumentControl from './DownloadDocumentControl';
import RenameDocumentControl from './RenameDocumentControl';

type Props = {
  file: UploadedFile;
  onDownload: (file: UploadedFile) => void;
};

export default function FiledDocumentInlineActions({ file, onDownload }: Props) {
  if (file.isFolder) return null;

  return (
    <Group gap="xxs" wrap="nowrap">
      <RenameDocumentControl
        fileId={file.file.id}
        currentName={file.file.fileName}
        variant="chip"
      />
      <DownloadDocumentControl onDownload={() => onDownload(file)} />
    </Group>
  );
}
